/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exp_Avg_Power_RangeInputs */

const en_exp_avg_power_range = /** @type {(inputs: Exp_Avg_Power_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compare to your FTP. Endurance rides: 55–75% FTP. Tempo: 76–90%. Threshold: 91–105%. Above threshold for sustained rides is very hard.`)
};

const de_exp_avg_power_range = /** @type {(inputs: Exp_Avg_Power_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vergleich mit FTP: Ausdauer 55–75% FTP. Tempo 76–90%. Schwelle 91–105%. Darüber auf langen Fahrten = sehr hart.`)
};

/**
* | output |
* | --- |
* | "Compare to your FTP. Endurance rides: 55–75% FTP. Tempo: 76–90%. Threshold: 91–105%. Above threshold for sustained rides is very hard." |
*
* @param {Exp_Avg_Power_RangeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const exp_avg_power_range = /** @type {((inputs?: Exp_Avg_Power_RangeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exp_Avg_Power_RangeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_exp_avg_power_range(inputs)
	return de_exp_avg_power_range(inputs)
});